// 页面类型
export const pageType = {
  homePage: 'homePage', //首页
  smartOrderPage: 'smartOrderPage', //智能工单提交页
  faqListPage: 'faqListPage', // faq列表页
  searchPage: 'searchPage', // 搜索页
  faqDetailPage: 'faqDetailPage', // faq详情页
  orderListPage: 'orderListPage', // 工单列表页
  orderDetailPage: 'orderDetailPage', // 工单详情页
  orderCreatePage: 'orderCreatePage', // 创建新工单页
  accountDeletePage: 'accountDeletePage' // 账号删除页
};

// 弹窗类型
export const popupType = {
  emailSubscribePopup: 'emailSubscribePopup', // 邮件订阅弹窗
  noticePopup: 'noticePopup' // 通知弹窗
};

// 按钮触发位置
export const locationType = {
  ...pageType,
  ...popupType
};

/**
  页面展示
  key: 页面类型key
  */
export const viewPage = key => {
  window.csorderDataLayer.push({
    eventName: 'view_page',
    eventType: pageType[key] || key || ''
  });
};

/**
  弹窗展示
  popupType: 描述弹窗类型
  */
export const showPopup = key => {
  window.csorderDataLayer.push({
    eventName: 'show_popup',
    eventType: popupType[key] || key || ''
  });
};

/**
  按钮点击
  btnName: 按钮名称
  reason: 按钮所属模块
  */
export const clickButton = ({ btnName, locationKey, otherParams }) => {
  window.csorderDataLayer.push({
    eventName: 'click_button',
    eventType: btnName || '',
    eventReason: locationType[locationKey] || locationKey || '',
    eventValue: otherParams
  });
};

/**
  各模块停留时长
  locationKey: 页面
  duration: 展示总时长
  */
export const sendStayTime = ({ locationKey, duration }) => {
  window.csorderDataLayer.push({
    eventName: 'stay_time',
    eventType: locationType[locationKey] || locationKey || '',
    eventValue: {
      duration
    }
  });
};
